<script setup lang="ts">
import CommonDialog from '@/components/common/dialog/CommonDialog.vue'
import { useConfirmDialog } from '@/composables/common/dialog/useConfirmDialog'

defineProps<{ title: string; message: string }>()

const { openModal } = useConfirmDialog()

defineExpose({
  openModal
})
</script>

<template>
  <CommonDialog size="md" ref="commonDialog" cancelTitle="閉じる" cancelOnly class="fs-5">
    <template #header>
      <h3 class="modal-title text-center">{{ title }}</h3>
    </template>
    <template #default>
      <div class="modal-body">
        <span>{{ message }}</span>
      </div>
    </template>
  </CommonDialog>
</template>

<style lang="scss" scoped>
.modal-title {
  width: 100%;
}
</style>
